export default import.meta.ROLLDOWN_FILE_URL_xpzrclStW7T9JPQ$qICj$w